"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lit_1 = require("lit");
// language=css
exports.default = (0, lit_1.css) `
  :host {
    --spacing-block: var(
      --wr-readmore-spacing-block,
      var(--wr-spacing-block, /*!*/ /*!*/)
    );
    --spacing-inline: var(
      --wr-readmore-spacing-inline,
      var(--wr-spacing-inline, /*!*/ /*!*/)
    );
    --margin-block: var(
      --wr-readmore-margin-block,
      var(--wr-margin-block, /*!*/ /*!*/)
    );
    --margin-inline: var(
      --wr-readmore-margin-inline,
      var(--wr-margin-inline, /*!*/ /*!*/)
    );

    /* Button properties */
    --button-color: var(
      --wr-readmore-button-color,
      var(--wr-color, /*!*/ /*!*/)
    );
    --button-background: var(--wr-readmore-button-background);
    --button-display: var(--wr-readmore-button-display);
    --button-width: var(--wr-readmore-button-width);
    --button-text-align: var(--wr-readmore-button-text-align);
    --button-font-weight: var(--wr-readmore-button-font-weight);

    --button-color-active: var(
      --wr-readmore-button-color-active,
      var(--wr-readmore-button-color)
    );
    --button-background-active: var(
      --wr-readmore-button-background-active,
      var(--wr-readmore-button-background)
    );
    --button-border-active: var(
      --wr-readmore-button-border-active,
      var(--wr-readmore-button-border)
    );

    --button-spacing: var(
      --wr-readmore-button-spacing,
      var(--spacing-block, /*!*/ /*!*/) var(--spacing-inline, /*!*/ /*!*/)
    );
    --button-margin: var(
      --wr-readmore-button-margin,
      var(--margin-block, /*!*/ /*!*/) var(--margin-inline, /*!*/ /*!*/)
    );
    --button-border: var(--wr-readmore-button-border, /*!*/ /*!*/);
    --button-border-radius: var(
      --wr-readmore-button-border-radius,
      /*!*/ /*!*/
    );

    /* Element properties */
    --animation-duration: var(
      --wr-readmore-animation-duration,
      var(--wr-animation-duration, 225ms)
    );
    --animation-timing: var(
      --wr-readmore-animation-timing,
      var(--wr-animation-timing, cubic-bezier(0.4, 0, 0.2, 1))
    );
    --animation-delay: var(
      --wr-readmore-animation-delay,
      var(--wr-animation-delay, 0s)
    );

    /* Overlay properties */
    --overlay-color: var(--wr-readmore-overlay-color);
    --overlay-height: var(
      --wr-readmore-overlay-height,
      var(--wr-readmore-height)
    );
  }

  .read-more__button {
    all: unset;
    cursor: pointer;
    color: var(--button-color);
    background: var(--button-background);
    padding: var(--button-spacing);
    margin: var(--button-margin);
    border: var(--button-border);
    border-radius: var(--button-border-radius);
    transition: background-color var(--animation-duration, /*!*/ /*!*/)
        var(--animation-timing, /*!*/ /*!*/) var(--animation-delay, /*!*/ /*!*/),
      color var(--animation-duration, /*!*/ /*!*/)
        var(--animation-timing, /*!*/ /*!*/) var(--animation-delay, /*!*/ /*!*/);
    border: var(--button-border);
    display: var(--button-display, inline);
    width: var(--button-width, auto);
    text-align: var(--button-text-align, inherit);
    font-weight: var(--button-font-weight, inherit);
  }

  .read-more__button:hover,
  .read-more__button:active,
  .read-more__button:focus {
    color: var(--button-color-active);
    background: var(--button-background-active);
    border: var(--button-border-active);
  }

  .read-more__content[data-overlay] {
    position: relative;
  }

  .read-more__content[data-overlay]::after {
    content: "";
    pointer-events: none;
    bottom: 0;
    left: 0;
    right: 0;
    background: var(--overlay-color);
    height: var(--overlay-height);
    display: block;
    width: 100%;
    position: absolute;
  }

  .read-more .read-more__content {
    overflow: hidden;
    max-height: var(--wr-readmore-height);
  }
`;
//# sourceMappingURL=styles.js.map